jQuery( document ).ready(function() {
    jQuery('body').prepend('<div role="alert" class="sr-only announce_cart"></div>');
    setTimeout(function(){ 
      jQuery('input.js-qty__num').attr('id','js-qty__num').before('<label for="js-qty__num" class="sr-only">input</label>');
      jQuery('input#ktc-keyword').before('<label for="ktc-keyword" class="sr-only">input</label>');
      jQuery('button#styles_upcartButtonMinus__PHPkf').prepend('<span class="sr-only">button</span>');
      jQuery('button#styles_upcartButtonPlus__2OF20').prepend('<span class="sr-only">button</span>');
      
      var a = document.getElementsByTagName("img");
    	for (e = 0; e < a.length; e++) {
    		var r = a[e].hasAttribute("alt");
    		if (0 == r && a[e].setAttribute("alt", "image"), 1 == r) "" == a[e].getAttribute("alt") && a[e].setAttribute("alt", "image")
    	}
    }, 3000);
    console.log( "ready!!" );
    jQuery('form#contact_form input[type="text"]').attr('id','name').prev().attr('for','name');
    jQuery('form#contact_form input[type="email"]').attr('id','email').prev().attr('for','email');
    jQuery('form#contact_form textarea').attr('id','textarea').prev().attr('for','textarea');
    jQuery('input[name="quantity"]').attr('id','qty').before('<label class="sr-only" for="qty">quantity</label>');
    jQuery('button[data-pf-type="QuantityButton"]').append('<span class="sr-only">button</span>');
    jQuery('button.splide__arrow--prev').append('<span class="sr-only">previous arrow</span>');
    jQuery('button.splide__arrow--next').append('<span class="sr-only">next arrow</span>');
    
    
    let targetNode = document.querySelector('body');
    
    function workOnClassAdd() {
       document.querySelector('.announce_cart').prepend('cart opened');
        setTimeout((function() {
          document.querySelector('.upcart-cart-body h3.upcart-product-title a').focus();
    	}), 2000)
       
    }
    
    function workOnClassRemoval() {
        document.querySelector('.announce_cart').innerHTML = "";
    }
    
    // watch for a specific class change
    class ClassWatcher {

      constructor(targetNode, classToWatch, classAddedCallback, classRemovedCallback) {
          this.targetNode = targetNode
          this.classToWatch = classToWatch
          this.classAddedCallback = classAddedCallback
          this.classRemovedCallback = classRemovedCallback
          this.observer = null
          this.lastClassState = targetNode.classList.contains(this.classToWatch)
  
          this.init()
      }
  
      init() {
          this.observer = new MutationObserver(this.mutationCallback)
          this.observe()
      }
  
      observe() {
          this.observer.observe(this.targetNode, { attributes: true })
      }
  
      disconnect() {
          this.observer.disconnect()
      }
  
      mutationCallback = mutationsList => {
          for(let mutation of mutationsList) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                  let currentClassState = mutation.target.classList.contains(this.classToWatch)
                  if(this.lastClassState !== currentClassState) {
                      this.lastClassState = currentClassState
                      if(currentClassState) {
                          this.classAddedCallback()
                      }
                      else {
                          this.classRemovedCallback()
                      }
                  }
              }
          }
      }
  }
    let classWatcher = new ClassWatcher(targetNode, 'upcartPopupShow', workOnClassAdd, workOnClassRemoval)
    
    
});